module.exports = __webpack_public_path__ + "assets/img/8141a36c1b7d7134028c2c1ccd6e56d3.svg";